import ActivityImportTable from '@app/components/imports/components/activity-import-table';
import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import {
  useGetImports,
  useImportsWithProgress,
} from '@shared/api/hooks/ccf/imports';
import { ImportTypeEnum, OperationReportTypeEnum } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';
import PurchasedGoodsImportPageToolbar from '../components/purchased-foods-imports-list-page-toolbar';

export default function PurchasedGoodsImportsListPage() {
  const { page, perPage } = useDataTableQueryState();

  const [fileName] = useQueryState('fileName', parseAsString);

  const { data, status } = useGetImports({
    page: page,
    page_size: perPage,
    importType: ImportTypeEnum.purchased_goods,
    search: fileName || undefined,
  });

  const mergedData = useImportsWithProgress(data);

  return (
    <Page name="Purchased goods imports">
      <PageHeader
        name="Purchase imports"
        toolbar={<PurchasedGoodsImportPageToolbar />}
      />
      <ActivityImportTable
        data={mergedData!}
        pageSize={perPage}
        status={status}
        reportType={OperationReportTypeEnum.purchase}
      />
    </Page>
  );
}
